import { StyledContainerWithScale } from 'src/styles/functions/getAnimationContainerDefaultStyles';
import styled, { css } from 'styled-components';
import { layout } from 'src/styles/layout';
import { palette } from 'src/styles/colors';
import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';

export const FreeTrialFormAnimatedWrapper = styled.div`
  position: relative;
  width: 100vw;
  overflow: hidden; // Hide bouncing bubble images from overlapping sections
  height: max(100vh, 700px);
  background: radial-gradient(ellipse at bottom, ${palette.lightTeal}, ${palette.accentBlue});

  ${applyStylesToMobileExperience(css`
    height: auto;
    padding-top: 2rem;
    padding-bottom: 2rem;
  `)}
`;

export const MovingContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;

  ${applyStylesToMobileExperience(css`
    position: relative;
    left: unset;
    top: unset;
    transform: none;
  `)}
`;

export const FreeTrialFormContainer = styled(StyledContainerWithScale)`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 6.5rem;
  box-sizing: border-box;

  ${applyStylesToMobileExperience(css`
    padding: 4rem 1.5rem;

    @media screen and (max-width: ${layout.xs}) {
      padding: 20px;
    }
  `)}
`;

export const FreeTrialFormContent = styled.div`
  border-radius: 24px;
  background: ${palette.white};
  box-shadow: 0px 0px 29.16426px 0px rgba(20, 25, 33, 0.14);
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  padding: 3.5rem 0rem;

  ${applyStylesToMobileExperience(css`
    padding: 2rem 1.5rem;
  `)}
`;
